import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';

@Component({
    selector: 'app-terms-conditions',
    templateUrl: './terms-conditions.component.html',
    standalone: true,
    imports: [CommonModule, NgxExtendedPdfViewerModule]
})
export class TermsAndConditionsComponent
{}
